import { fadeInOut } from '../../shared/classes/animations';
import { StorageService } from '../../shared/services/storage.service';
import { Component, OnInit } from '@angular/core';
import { AgenceService } from '../../agence/shared/services/agence.service';
import { ConfigurationService } from '../../configuration/shared/services/configuration.service';
import { ConfigurationClientService } from '../services/configuration-client.service';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.css'],
    animations: [fadeInOut],
})
export class FooterComponent implements OnInit {
    
    organisation: any;
    madeInLuxembourgLogo = '/assets/made_in_luxembourg.png';
    cciHeaderFooterColor: string;
    cciNavTextColor: string;

    constructor(
        private agenceService: AgenceService,
        private storageService: StorageService,
        private configService: ConfigurationService,
        private configClientService: ConfigurationClientService
    ) { }

    ngOnInit() {
        this.getOrganisation();

        this.configClientService.getConfiguration()
        .subscribe(retour => {
            if (retour.status === 200) {   
                this.cciHeaderFooterColor = retour.data.cci_header_footer_color;
                this.cciNavTextColor = retour.data.cci_nav_text_color;
            }
        });
    }


    getOrganisation() {
        this.agenceService.getOrganisation()
        .subscribe(retour => {
            if (retour.status === 200) {
                this.organisation = retour.data;
                this.storageService.setTypeVersion(this.organisation.org_pays);
            }
        });
    }

    changeHeaderFooterColor(): any {
        return { 'background-color': this.cciHeaderFooterColor };
    }

    changeNavTextColor(): any {
        return { 'color': this.cciNavTextColor };
    }

}
